import { render, staticRenderFns } from "./ItemCombination.vue?vue&type=template&id=6ae42678"
import script from "./ItemCombination.vue?vue&type=script&lang=js"
export * from "./ItemCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports